'use strict';

app.config(function ($popupProvider) {
  $popupProvider.define('doc-save', function (params) {
    return /*@ngInject*/ {
      windowClass: 'prompt-modal',
      template: [
        '<div class="prompt">',
          '<div class="prompt-body">Your <span ng-bind-html="documentNames.join(\', <br/>\')"></span> has been saved to your docs.</div>',
          '<div class="prompt-footer">',
            '<button class="btn btn-go" ng-click="$close()">Ok</button> ',
          '</div>',
        '</div>'
      ].join(''),
      controller: function ($scope) {
        $scope.documentNames = params.documentNames;
      }
    };
  });

});
